__turbopack_context__.v({
  "content": "EventFAQs-module-scss-module__zoQjPq__content",
  "title": "EventFAQs-module-scss-module__zoQjPq__title",
});
